<template>
  <div>
    <v-card align="left">
      <v-card-title> Members </v-card-title>
      <v-card-subtitle>{{ householdname }}</v-card-subtitle>
      <v-card-text>
        <template v-for="member in members">
          <v-list-item :key="member.id">
            <v-list-item-content>
              <v-list-item-title
                >{{ member.firstName }} {{ member.lastName }}
                <v-chip outlined small v-if="member.guest" color="primary"
                  >Guest</v-chip
                >
                <v-chip
                  outlined
                  small
                  v-if="member.role == 'tenant'"
                  color="secondary"
                  >tenant</v-chip
                >
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ member.color }} {{ member.carModel }}
                <strong> {{ member.licensePlate }} </strong>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { membersRef } from "../../firebaseApp";
export default {
  props: ["household", "householdname"],
  data: () => ({
    members: [],
  }),
  watch: {
    household: function () {
      this.loadMembers();
    },
  },
  methods: {
    deleteMember(key, index) {
      this.members.splice(index, 1);
      membersRef.child(key).remove();
    },
    loadMembers() {
      let members = [];
      if (this.household != undefined && this.household != "") {
        let household = this.household;
        membersRef.on("value", (snap) => {
          snap.forEach((member) => {
            if (member.val().householdKey == household) {
              let mem = {};
              mem = member.val();
              mem.id = member.key;
              members.push(mem);
            }
          });
          if (members.length) {
            this.members = members;
          }
        });
      }
    },
  },
  mounted() {
    this.loadMembers();
  },
  created() {},
};
</script>